import { getSolanaConnection } from '../connection';
import { decodeVaultState } from '../decoders/vaultState';
import { getGlobalDumpVaultPda } from '../pdas/globalDumpVault';

export function subscribeToGlobalDumpVault(onUpdate, onError) {
  const connection = getSolanaConnection();
  const publicKey = getGlobalDumpVaultPda();

  const subscriptionId = connection.onAccountChange(
    publicKey,
    (accountInfo) => {
      try {
        onUpdate({
          publicKey: publicKey.toBase58(),
          lamports: accountInfo.lamports,
          data: decodeVaultState(accountInfo.data),
          updatedAt: Date.now(),
        });
      } catch (error) {
        onError?.(error);
      }
    },
    'confirmed'
  );

  return () => connection.removeAccountChangeListener(subscriptionId);
}
